<template>
  <section id="empresas">
    <div>
      <h3>
        Empresas, Organismos y Municipios que lo están usando:
      </h3>

      <div class="mt-5">
        <BrandSlider :logos="slider1" :speed="50" />
        <BrandSlider :logos="slider2" direction="right" :speed="155" />
        <BrandSlider :logos="slider3" :speed="47" />
      </div>
    </div>
  </section>
</template>

<script>
import BrandSlider from "./BrandSlider.vue";

export default {
  name: "Empresas",
  components: { BrandSlider },
  data() {
    return {
      slider1: [
        "/assets/img/home/aosc.png",
        "/assets/img/home/recursos-naturales.png",
        "/assets/img/home/ministerio.png",
        "/assets/img/home/rentas.png",
        "/assets/img/home/dpec.png",
        "/assets/img/home/invico.png",
        "/assets/img/home/cultura.png",
        "/assets/img/home/unne.png",
        // agrega más rutas de logos
      ],
      slider2: [
        "/assets/img/home/bellavista.png",
        "/assets/img/home/caacati.png",
        "/assets/img/home/corrientes.png",
        "/assets/img/home/curuzu.png",
        "/assets/img/home/goya.png",
        "/assets/img/home/itati.png",
        "/assets/img/home/ituzaingo.png",
        "/assets/img/home/lavalle.png",
        "/assets/img/home/montecaseros.png",
        "/assets/img/home/paso.png",
        "/assets/img/home/riachuelo.png",
        "/assets/img/home/saladas.png",
        "/assets/img/home/sancarlos.png",
        "/assets/img/home/sauce.png",
        "/assets/img/home/santotome.png",
        "/assets/img/home/virasoro.png",

        // agrega más rutas de logos
      ],
      slider3: [
        "/assets/img/home/blinker.png",
        "/assets/img/home/boca-unidos.png",
        "/assets/img/home/colegio-escribanos.png",
        "/assets/img/home/viking.png",
        "/assets/img/home/ciencias-economicas.png",

        // agrega más rutas de logos
      ],
    };
  },
};
</script>

<style scoped>
/* EMPRESAS  */
#empresas {
  color: #00b1eb;
  text-align: center;
  background: #fff;
  margin-top: -280px;
  position: relative;
  z-index: 1000;
  padding-top: 50px;
}

.empresas-image {
  max-width: 100%;
  margin: auto;
}

h3 {
  font-weight: bold;
  font-size: 35px;
}

@media (max-width: 1550px) {
  .empresas-image {
    padding: 0 12%;
  }
}

@media (max-width: 1280px) {
  #empresas {
    margin-top: -220px;
  }

  h3 {
    font-size: 25px;
  }
}

@media (max-width: 1024px) {
  #empresas {
    margin-top: -180px;
  }

  h3 {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  #empresas {
    margin-top: -60px;
    padding: 0 6%;
    padding-top: 10px;
  }

  .empresas-image {
    padding: 0%;
  }
}

@media (max-width: 600px) {
  h3 {
    font-size: 16px;
    padding: 0 8%;
  }
}
</style>
